export default [{"url":"https://jabara-0.api.invexerp.io","name":"Branch 1","port":"5019","isStore":true,"isHQ":true}]